<template>
    <DateRangeFilter v-model="range" :title="facet.title" :optionSet="optionSet" />
</template>

<script>
import { unixSeconds } from '@/utils/date'
import { createNamedDateRangeCriterion, createRangeCriterion } from '@/utils/filters'
import { iso8601Date } from '@/utils/format'

import DateRangeFilter from '../date-range-filter.vue'

export default {
    components: {
        DateRangeFilter,
    },
    props: {
        criteria: {
            type: Array,
            required: true,
            default() {
                return []
            },
        },
        facet: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    computed: {
        criterion() {
            return (
                this.criteria.find(c => c.name === this.facet.name) || {
                    display: 'All Dates',
                }
            )
        },
        range: {
            get() {
                let current = this.criterion

                let minDate = current.min ? iso8601Date(new Date(current.min * 1000)) : null
                let maxDate = current.max ? iso8601Date(new Date(current.max * 1000)) : null

                return {
                    startDate: minDate ?? current?.complexValue?.start,
                    endDate: maxDate ?? current?.complexValue?.end,
                    display:
                        current?.display?.indexOf(this.facet.title) === 0
                            ? current?.display?.substr(this.facet.title.length + 2)
                            : current?.display,
                    isNamedRange: current.isNamedRange ?? false,
                }
            },
            set(range) {
                let criterion

                if (range.isNamedRange) {
                    criterion = createNamedDateRangeCriterion(this.facet.name, this.facet.title, range.display)
                } else {
                    criterion = createRangeCriterion(
                        this.facet.name,
                        this.facet.title,
                        'date-range',
                        unixSeconds(range.startDate),
                        unixSeconds(range.endDate)
                    )
                }

                criterion.complexValue = {
                    start: range.startDate,
                    end: range.endDate,
                }

                let criteria = this.criteria.slice()
                let index = criteria.findIndex(c => c.name === this.facet.name)

                if (index < 0) {
                    criteria.push(criterion)
                } else {
                    criteria[index] = criterion
                }

                this.$emit('update:criteria', criteria)
            },
        },
        optionSet() {
            return this.facet.options?.set ?? 'default'
        },
    },
}
</script>
